import { createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: {
      main: '#707070'
    },
    secondary: {
      main: '#0B62e5'
    },
    info: {
      main: '#f0f0f0'
    },
    success: {
      main: '#ffffff'
    },
    warning: {
      main: '#ff9c01'
    },
    error: {
      main: '#e60012'
    }
  },
  typography: {
    fontSize: 16,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 700,

    h1: { fontSize: 24, fontWeight: 'bold' },
    h2: { fontSize: 20, fontWeight: 'bold' },
    h3: { fontSize: 18, fontWeight: 'bold' },
    h4: { fontSize: 16, fontWeight: 'bold' },
    h5: { fontSize: 14, fontWeight: 'bold' },
    h6: { fontSize: 12, fontWeight: 'bold' },
    subtitle1: { fontSize: 16, fontWeight: 'bold' },
    subtitle2: { fontSize: 14, fontWeight: 'bold' },
    body1: { fontSize: 16 },
    body2: { fontSize: 14 },
    caption: { fontSize: 12 },
    button: { fontWeight: 'normal', textTransform: 'none' }
  }
});

export default theme;
